export const NOW = 'now';
export const ONE_HOUR = 'one_hour';
export const FIVE_HOURS = 'five_hours';
export const TWENTYFOUR_HOURS = 'twenty_four_hours';
